import Loadable from 'react-loadable';

import LoadableLoadingPage from './LoadableLoadingPage';

export default Loadable({
  loader: () =>
    import(
      /* webpackChunkName: "gradSchools/GradProgramPageContainer" */
      './GradProgramPageContainer'
    ),
  loading: LoadableLoadingPage,
});
